import { call, put } from '@redux-saga/core/effects';
import { api, apiErrorHandler, notify } from 'services';
import {
  CreateAreaActions as Actions,
  CreateAreaRequestAction as RequestAction,
} from 'store/ducks/areas';

export function* createAreaRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, 'areas', postData);
    onSuccess && onSuccess();
    notify('success', 'Área criada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
